enum Environment {
    PROD = 'prod',
    DEV = 'dev',
    TEST = 'test',
}

// 当前的环境
const ENV: Environment = Environment.PROD;

// 登录回调地址 - 生产环境
const CALL_BACK_URL_PROD = 'https://news.cgtn.com/game/wordarena/index.html';
// 获取用户头像信息的地址 - 生产环境
const GET_USER_INFO_AVATAR_PROD = 'https://account.user.cgtn.com/user/getById';
// origin
const GET_USER_INFO_AVATAR_ORIGIN_PROD = 'https://passport.user.cgtn.com';
// 官方cgtn退出登录的地址 - 生产环境
const SING_OUT_URL_PROD = 'https://account.user.cgtn.com/user/exit?redirectToUrl='
// 分享链接 - 生产环境
const SHARE_URL_PROD = "https://news.cgtn.com/game/wordarena/index.html";
// 要分享出去的网站的图标
const SHARE_URL_ICON_PROD = 'https://news.cgtn.com/game/wordarena/home_logo.png';
// 基本的api请求地址 - 生产环境
const BASE_API_URL_PROD = 'https://wordarena-api.cgtn.com/api/game/';

// 基本的api请求地址 - 本地开发环境
// const BASE_API_URL_TEST = 'http://localhost:8080/api/game/';

// 基本的api请求地址 - 官方测试环境
const BASE_API_URL_TEST = 'https://gameapitest.ivideofactory.com/api/game/';
// 登录回调地址 - 测试环境
const CALL_BACK_URL_TEST = 'https://newscntest.cgtn.com/game/wordarena/index.html';
// 获取用户头像信息的地址 - 测试环境
const GET_USER_INFO_AVATAR_TEST = 'https://account.user.cgtn.com/user/getById';
// origin
const GET_USER_INFO_AVATAR_ORIGIN_TEST = 'https://test-passport.user.cgtn.com';
// 官方cgtn登录地址
const CGTN_LOGIN_URL_TEST = 'https://passport.user.cgtn.com/#/login?redirectToUrl='
// 官方cgtn登录地址
const CGTN_LOGIN_URL_PROD = 'https://passport.user.cgtn.com/#/login?redirectToUrl='

// 官方cgtn退出登录的地址 - 测试环境
const SING_OUT_URL_TEST = 'https://account.user.cgtn.com/user/exit?redirectToUrl='
// 分享链接 - 测试环境
const SHARE_URL_TEST = "https://newscntest.cgtn.com/game/wordarena/index.html";

// 要分享出去的网站的图标
const SHARE_URL_ICON_TEST = 'https://newscntest.cgtn.com/game/wordarena/home_logo.png';

export class UrlConfig {
    // 生产环境
    public static readonly CGTN_LOGIN_URL = ENV === Environment.PROD ? CGTN_LOGIN_URL_PROD : CGTN_LOGIN_URL_TEST;
    // 基本的页面地址 1
    public static readonly CALL_BACK_URL = ENV === Environment.PROD ? CALL_BACK_URL_PROD : CALL_BACK_URL_TEST;
    // 获取用户头像信息的地址
    public static readonly GET_USER_INFO_AVATAR = ENV === Environment.PROD ? GET_USER_INFO_AVATAR_PROD : GET_USER_INFO_AVATAR_TEST;
    // 获取用户头像信息的地址中的origin
    public static readonly GET_USER_INFO_AVATAR_ORIGIN = ENV === Environment.PROD ? GET_USER_INFO_AVATAR_ORIGIN_PROD : GET_USER_INFO_AVATAR_ORIGIN_TEST;
    // 基本的api请求地址
    public static readonly BASE_API_URL = ENV === Environment.PROD ? BASE_API_URL_PROD : BASE_API_URL_TEST;
    // 官方cgtn退出登录的回调 1
    public static readonly SING_OUT_URL = ENV === Environment.PROD ? SING_OUT_URL_PROD : SING_OUT_URL_TEST;

    // 分享里安卓手机需要有个分享地址
    public static readonly SHARE_URL = ENV === Environment.PROD ? SHARE_URL_PROD : SHARE_URL_TEST;
    // 单独分享出去的时候home_logo的链接
    public static readonly SHARE_URL_HOME_LOGO = ENV === Environment.PROD ? SHARE_URL_ICON_PROD : SHARE_URL_ICON_TEST;
}